import { checkMenuGuard } from '@/common/utils';

export const routes = [
  {
    path: '/market-access',
    name: 'MarketAccess',
    component: () => import('@/app/modules/MarketsAccess/MarketAccess.vue'),
  },
  {
    path: '/market-access/restriction/:id?',
    name: 'MarketAccessRestriction',
    component: () => import('@/app/modules/MarketsAccess/components/restriction/MarketAccessRestriction.vue'),
  },
  {
    path: '/market-access/duties-and-taxes/:id?',
    name: 'MarketAccessTaxes',
    component: () => import('@/app/modules/MarketsAccess/components/MarketAccessTaxes.vue'),
  },
  {
    path: '/market-access/action-list',
    name: 'ActionsList',
    component: () => import('@/app/modules/MarketsAccess/components/ActionsList.vue'),
  },
  {
    path: '/market-access/action-list/:id',
    name: 'ActionListItem',
    component: () => import('@/app/modules/MarketsAccess/components/ActionListItem.vue'),
  },
  {
    path: '/market-access/support',
    name: 'MarketAccessSupport',
    component: () => import('@/app/modules/MarketsAccess/components/MarketAccessSupport.vue'),
  },
  {
    path: '/market-access/monitoring-world-prices',
    name: 'MonitoringWorldPrices',
    component: () => import('@/app/modules/MarketsAccess/components/MonitoringWorldPrices.vue'),
    beforeEnter: checkMenuGuard,
  },
];
